import Quill from "quill";

const QuillClipboard = Quill.import("modules/clipboard");
const Delta = Quill.import("delta");

const COLOR_NODE = [
  Node.ELEMENT_NODE,
  (node, delta) => {
    return delta.compose(
      new Delta().retain(delta.length(), {
        color: false
      })
    );
  }
];

export class Clipboard extends QuillClipboard {
  constructor(quill, options) {
    super(quill, {
      ...options,
      matchers: [COLOR_NODE]
    });
    this.imageBlob = [];
    this.addMatcher("IMG", this.imageMatcher());
    this.addMatcher(Node.TEXT_NODE, this.textMatcher());
  }

  copyPasteHandler(url) {
    if (!this.quill.flowType && !this.quill.flowId) {
      console.info("flowtype and flowid is mandatory");
      return;
    }
    if (!this.quill.options.onFilePaste) return;
    if (this.imageBlob.length > 0) {
      this.quill.options.onFilePaste(this.imageBlob);
    }
  }

  imageMatcher() {
    return (node, delta) => {
      this.copyPasteHandler(node.src);
      return new Delta();
    };
  }

  textMatcher() {
    return (node, delta) => {
      var regex = /https?:\/\/[^\s]+/g;
      if (typeof node.data !== "string") return;
      var matches = node.data.match(regex);
      if (matches && matches.length > 0) {
        var ops = [];
        var str = node.data;
        matches.forEach(function updateTextMatch(match) {
          var split = str.split(match);
          var beforeLink = split.shift();
          ops.push({ insert: beforeLink });
          ops.push({ insert: match, attributes: { link: match } });
          str = split.join(match);
        });
        ops.push({ insert: str });
        delta.ops = ops;
      }
      return delta;
    };
  }

  async onPaste(e) {
    let text = e.clipboardData.getData("text/plain");
    if (this.quill.restrictPasteHandler) {
      this.quill.pastedText = text;
      return;
    }
    let items = e.clipboardData.items;
    this.imageBlob = [];
    for (var i = 0; i < items.length; i++) {
      this.imageBlob.push(items[i].getAsFile());
    }
    if (e.target.tagName !== "BR" && e.target.closest(".custom-block"))
      return false;
    const { urlRegEx } = await import("base/form");
    if (text.match(urlRegEx)) {
      let range = this.quill.getSelection();
      let delta = new Delta().retain(range.index);
      let scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(Quill.sources.SILENT);
      let newDelta = new Delta();
      /** regex to check if the url is kf post url to support shared_post */
      let regex = new RegExp(`${window.location.host}/view/(channel|team)`);
      if (text.match(regex)) {
        let urlSplit = regex.exec(text).input.split("/");
        newDelta
          .insert(text, {
            link: text
          })
          .insert({
            shared_post: {
              href: text,
              medium: urlSplit[4],
              mediumId: urlSplit[5],
              postId: urlSplit[7]
            }
          })
          .insert("\n");
      } else {
        newDelta.insert(text, {
          link: text
        });
        if (this.quill?.options?.formats?.includes("embed_link")) {
          newDelta.insert({
            embed_link: {
              href: text
            }
          });
        }
        if (this.quill.onLinkPaste) {
          this.quill.onLinkPaste(text);
        }
      }
      setTimeout(() => {
        this.container.innerHTML = "";
        delta = delta.concat(newDelta).delete(range.length);
        this.quill.updateContents(delta, Quill.sources.USER);
        this.quill.setSelection(
          delta.length() - range.length,
          Quill.sources.SILENT
        );
        this.quill.scrollingContainer.scrollTop = scrollTop;
        this.quill.focus();
      }, 1);
    } else {
      super.onPaste(e);
    }
  }
}
